module.exports = __webpack_public_path__ + "img/CheckList.d04295ab.svg";